export const queryKeys = {
  // Consolidate all your query keys here
  auth: {
    testApi: ["auth", "test-api"] as const,
  },
  dbTest: {
    list: ["db-test", "list"] as const,
  },
} as const;
